import React, { useEffect, useRef } from 'react';

const ACHIEVEMENTS = {
  first_blood:     { name: "First Blood", icon: "🗡️", rarity: "common" },
  slayer:          { name: "Slayer", icon: "⚔️", rarity: "uncommon" },
  genocide:        { name: "Genocide", icon: "💀", rarity: "rare" },
  annihilator:     { name: "Annihilator", icon: "☠️", rarity: "mythic" },
  battle_hardened: { name: "Battle Hardened", icon: "🛡️", rarity: "common" },
  veteran:         { name: "Veteran", icon: "⭐", rarity: "uncommon" },
  warmonger:       { name: "Warmonger", icon: "🔥", rarity: "rare" },
  eternal_warrior: { name: "Eternal Warrior", icon: "⚔️", rarity: "mythic" },
  apprentice:      { name: "Apprentice", icon: "🔮", rarity: "common" },
  archmage:        { name: "Archmage", icon: "🧙", rarity: "uncommon" },
  spell_weaver:    { name: "Spell Weaver", icon: "✨", rarity: "rare" },
  god_of_magic:    { name: "God of Magic", icon: "🌌", rarity: "mythic" },
  heavy_hitter:    { name: "Heavy Hitter", icon: "💪", rarity: "common" },
  thunder_strike:  { name: "Thunder Strike", icon: "⚡", rarity: "uncommon" },
  cataclysm:       { name: "Cataclysm", icon: "☄️", rarity: "rare" },
  god_of_war:      { name: "God of War", icon: "💫", rarity: "mythic" },
  one_shot:        { name: "One-Shot", icon: "💥", rarity: "uncommon" },
  obliterate:      { name: "Obliterate", icon: "🔨", rarity: "rare" },
  smite_of_god:    { name: "Smite of God", icon: "☀️", rarity: "mythic" },
  lucky:           { name: "Lucky", icon: "🍀", rarity: "common" },
  crit_master:     { name: "Crit Master", icon: "🎯", rarity: "uncommon" },
  fate_bender:     { name: "Fate Bender", icon: "🌀", rarity: "rare" },
  chosen_by_dice:  { name: "Chosen by Dice", icon: "🎲", rarity: "mythic" },
  bruised:         { name: "Bruised", icon: "🩹", rarity: "common" },
  bloodied:        { name: "Bloodied", icon: "🩸", rarity: "uncommon" },
  iron_will:       { name: "Iron Will", icon: "🫀", rarity: "rare" },
  unbreakable:     { name: "Unbreakable", icon: "🗿", rarity: "mythic" },
  first_fall:      { name: "First Fall", icon: "💔", rarity: "common" },
  deaths_familiar: { name: "Death's Familiar", icon: "☠️", rarity: "uncommon" },
  revolving_door:  { name: "Revolving Door", icon: "👻", rarity: "rare" },
  eternal_returner:{ name: "Eternal Returner", icon: "💀", rarity: "mythic" },
  tpk:             { name: "Total Party Kill", icon: "🪦", rarity: "rare" },
  unkillable:      { name: "Unkillable", icon: "👑", rarity: "mythic" },
  student:         { name: "Student", icon: "📖", rarity: "common" },
  scholar:         { name: "Scholar", icon: "📚", rarity: "uncommon" },
  sage:            { name: "Sage", icon: "🎓", rarity: "rare" },
  ascended:        { name: "Ascended", icon: "🌟", rarity: "mythic" },
  first_aid:       { name: "First Aid", icon: "💚", rarity: "common" },
  medic:           { name: "Medic", icon: "🩺", rarity: "uncommon" },
  divine_healer:   { name: "Divine Healer", icon: "🕊️", rarity: "rare" },
  miracle_worker:  { name: "Miracle Worker", icon: "✝️", rarity: "mythic" },
  pest:            { name: "Pest", icon: "🦟", rarity: "common" },
  plague_bearer:   { name: "Plague Bearer", icon: "🧬", rarity: "uncommon" },
  curse_master:    { name: "Curse Master", icon: "🧿", rarity: "rare" },
  coin_purse:      { name: "Coin Purse", icon: "🪙", rarity: "common" },
  merchant:        { name: "Merchant", icon: "💰", rarity: "uncommon" },
  dragon_vault:    { name: "Dragon's Vault", icon: "🏦", rarity: "rare" },
  overkill:        { name: "Overkill", icon: "💣", rarity: "uncommon" },
  alpha_strike:    { name: "Alpha Strike", icon: "🎯", rarity: "uncommon" },
  flawless:        { name: "Flawless", icon: "💠", rarity: "rare" },
  last_stand:      { name: "Last Stand", icon: "🫡", rarity: "rare" },
  speed_demon:     { name: "Speed Demon", icon: "⚡", rarity: "rare" },
  marathon:        { name: "Marathon", icon: "🏃", rarity: "rare" },
  breather:        { name: "Breather", icon: "☀️", rarity: "uncommon" },
  hibernator:      { name: "Hibernator", icon: "🌙", rarity: "uncommon" },
  session_10:      { name: "Dedicated", icon: "📅", rarity: "common" },
  session_25:      { name: "Regular", icon: "📅", rarity: "uncommon" },
  session_50:      { name: "Campaign Veteran", icon: "📜", rarity: "rare" },
  session_100:     { name: "Living Legend", icon: "🏛️", rarity: "mythic" },
  godmode:         { name: "Ascendant", icon: "🌌", rarity: "rare" },
};

export default function AchievementBadge({ id }) {
  const ach = ACHIEVEMENTS[id];
  const badgeRef = useRef(null);

  useEffect(() => {
    if (!ach || ach.rarity !== 'mythic') return;
    const el = badgeRef.current;
    const interval = setInterval(() => {
      const p = document.createElement('div');
      p.className = 'mythic-particle';
      const dx = (Math.random() - 0.5) * 40;
      const dy = -(Math.random() * 50 + 10);
      p.style.setProperty('--dx', dx + 'px');
      p.style.setProperty('--dy', dy + 'px');
      p.style.left = (30 + Math.random() * 30) + 'px';
      p.style.top = (10 + Math.random() * 50) + 'px';
      p.style.width = (1 + Math.random() * 2) + 'px';
      p.style.height = p.style.width;
      p.style.background = Math.random() > 0.5 ? '#fff' : '#ff9a9a';
      el.appendChild(p);
      setTimeout(() => p.remove(), 1800);
    }, 20);
    return () => clearInterval(interval);
  }, [ach]);

  if (!ach) return null;

  return (
    <div className={`badge badge-${ach.rarity}`} ref={badgeRef} title={ach.name}>
      <div className="badge-ring"><div className="badge-inner">{ach.icon}</div></div>
      <div className="badge-label">{ach.name}</div>
    </div>
  );
}

export { ACHIEVEMENTS };
